<!--
https://docs.google.com/document/d/1JOy1cSFY-KGBVHjjZMcWkEtaLlliAzMHHh6ceHp8gBo/edit
https://xd.adobe.com/view/8cb33f5b-1ca6-42ef-a4f3-3afae476dfde-d9e0/specs/
https://docs.google.com/presentation/d/1KoLwxK6SmXHDFyi8c-3t10mt-BctVg1eYVhkBoeIMSY/edit#slide=id.p
https://xd.adobe.com/view/a72aa57e-4132-4ad7-85d3-a356af6492d9-f279/screen/0526d045-9259-481d-8194-c1f27fef5749/
https://xd.adobe.com/view/ecb56c10-7c32-454b-bf77-7b63fc81173e-b9e6/specs/
-->
<template>
  <div id="paymentmanagement" class="clearfix px3 notosans darkblue">
      <div class="pointer mt2" @click="gotodashboard()">
        <i class="el-icon-back h5"></i>
      </div>
      <div class="darkblue-background px3 py4 mt2 flex flex-column items-start justify-center rounded">
            <p class="h3 white col-12 line-height-golden bold ">Anmod om betaling</p>
            <p class="h6 white col-12 line-height-golden">Du anmoder om betaling for rater ud fra jeres kontrakt</p>
      </div>
      <div class="col-12" v-if="loading">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="col-12 py3 px0 xs-mb3 flex darkblue justify-around flex-wrap gap-10">
          <!-- <div class="headerboxitem flex flex-column items-center justify-center">
            <p class="h5 semi-bold">{{currentContractData['PROJECT']['NAME']}}</p>
            <p class="h6">Projekt</p>
          </div> -->
          <!-- <div class="headerboxitem flex flex-column p2 justify-center">
              <div class="h4 m0 flex">
                <span><i class="el-icon-document"></i></span>
                <span class="h3 m0 ml-auto semi-bold">{{Number(totalamount).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
              </div>
              <p class="h6 ml-auto m0">Kontrakt Pris</p>
          </div> -->
          <div class="headerboxitem flex flex-column p2 justify-center">
              <div class="h4 m0 flex">
                <span><i class="el-icon-document"></i></span>
                <span class="h3 xs-h6 m0 ml-auto semi-bold">{{parseFloat(tilbudpris).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
              </div>
              <p class="h6 ml-auto m0">Wallet</p>
          </div>
          <div class="headerboxitem flex flex-column p2 justify-center">
              <div class="h4 m0 flex">
                <span><i class="el-icon-document"></i></span>
                <span class="h3 xs-h6 m0 ml-auto semi-bold">{{totalrelease.toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
              </div>
              <p class="h6 ml-auto m0">Betalt</p>
          </div>
          <div class="headerboxitem flex flex-column p2 justify-center">
              <div class="h4 m0 flex">
                <span><i class="el-icon-document"></i></span>
                <span class="h3 m0 xs-h6 ml-auto semi-bold" v-if="parseFloat(tilbudpris - totalrelease) >= 0">{{parseFloat(tilbudpris - totalrelease).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
                <span class="h3 m0 xs-h6 ml-auto semi-bold" v-else>{{(0).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
              </div>
              <p class="h6 ml-auto m0">Saldo</p>
          </div>
          <div class="headerboxitem flex flex-column p2 justify-center">
              <div class="h4 m0 flex">
                <span><i class="el-icon-document"></i></span>
                <span class="h3 m0 xs-h6 ml-auto semi-bold">{{parseFloat(mangelamount).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</span>
              </div>
              <p class="h6 ml-auto m0">Sikkerhedsstillelse</p>
          </div>
        </div>
        <div class=" pt0 rounded">
          <!-- <div class="darkblue-background p0 m0 col-12 flex white justify-between items-center py1">
            <p class="font14 p0 m0 col-2 center">Task</p>
            <p class="font14 p0 m0 col-2 center">Pris</p>
            <p class="font14 p0 m0 col-2">Status</p>
            <p class="font14 p0 m0 col-2">billeder</p>
            <p class="font14 p0 m0 col-2">At anmode</p>
          </div> -->
          <div class="border darkblue-border rounded">
          <el-collapse v-model="activeTab">
            <!-- eslint-disable -->
            <el-collapse-item :name="enterpriserstage.enterpriserID" v-for="(enterpriserstage,index) in allstagesArr" class="my2" :key="index">
            <template slot="title">
              <div class="darkblue-background p0 m0 col-12 flex white justify-between items-center py1 rounded">
                <p class="white m0 p1 md-col-2 lg-col-2 sm-col-2 xs-col-10 flex" v-if="enterpriserstage.enterpriserID !== 'extra_work'"><span class="pr1 h6">{{parseInt(index + 1) + '. ' + enterpriserstage.enterpriserNAME}}</span></p>
                <p class="white m0 p1 md-col-2 lg-col-2 sm-col-2 xs-col-10 flex" v-else><span class="pr1">Ekstra arbejde</span></p>
                <!-- <p class="font14 p0 m0 col-2 center">Task</p> -->
                <p class="font14 p0 m0 col-2 xs-hide center">Pris</p>
                <p class="font14 p0 m0 col-2 xs-hide">Status</p>
                <p class="font14 p0 m0 col-2 xs-hide">billeder</p>
                <p class="font14 p0 m0 col-2 xs-hide">At anmode</p>
              </div>
            </template>
            <div id="jobindustryheader" class="col-12 p0 flex mt2" v-for="(stage,index2) in enterpriserstage['enterpriserstages']" :key="index2">
              <el-collapse v-model="activeJobID" class="col-12 px2  mb2 white-background " @change="handleChange">
                <el-collapse-item :name="stage.INDUSTRY + enterpriserstage.enterpriserID">
                  <template slot="title">
                      <div class="flex items-center px1 col-3 pointer">
                        <p class="darkblue mr-auto m0 py1 flex" v-if="enterpriserstage.enterpriserID !== 'extra_work'"><span class="pr1">{{index + 1}}.{{index2 + 1}}</span><span>{{stage.INDUSTRY}}</span></p>
                        <p class="darkblue mr-auto m0 py1 flex" v-else><span class="pr1">{{index + 1}}.{{index2 + 1}}</span><span>{{stage.DESCRIPTION[0]}}</span></p>
                      </div>
                      <!-- <div class="flex flex-column">
                        <p class="" v-for="(item,index) in stage.DESCRIPTION" :key="index">{{item}}</p>
                      </div> -->
                      <div class="flex items-center justify-start px1 sm-col-2 lg-col-2 md-col-2 xxl-col-2 xs-col-12">
                        <p class="font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center">Pris</p>
                        <p class="darkblue mr-auto xs-ml-auto m0 py1">{{parseFloat(stage.PRICE_DEDUCTED).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</p>
                      </div>
                      <div class="flex items-center px1 justify-start sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12">
                        <p class="font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center">Status</p>
                        <p id="paidbutton" class="paymentbutton action-button regular font12 flex items-center justify-center xs-ml-auto" v-if="stage.STATUS === 'paid'">Betalt</p>
                        <p class="paymentbutton primary-button font12 flex items-center justify-center xs-ml-auto" v-else-if="stage.STATUS === 'requested'">Anmodet om</p>
                        <p class="paymentbutton yellow-button font12 flex items-center justify-center xs-ml-auto" v-else-if="stage.STATUS === 'pending'">Verserende</p>
                        <p class="paymentbutton dark-button font12 flex items-center justify-center xs-ml-auto" v-else-if="stage.STATUS === 'partially_paid'">Delvist betalt</p>
                        <p @click="showdecline(stage.STATUS)" class="paymentbutton delete-button font12 flex items-center justify-center xs-ml-auto" v-else-if="stage.STATUS === 'declined'">Afvist</p>
                      </div>
                      <div :id="'imageuploader'" @click="getstageid(stage.ID)" class="flex items-center px1 sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 ">
                        <p class="font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center">billeder</p>
                        <div v-if="innerimageloading">
                          <i class="el-icon-loading"></i>
                        </div>
                        <div class="p0 pb2 relative xs-ml-auto" v-else>
                          <img :id="'imagedivreview' + stage.ID" :src="stage.PHOTOS[0] + '?width=125&height=80'" @click="opengallery(stage.PHOTOS, index, index2)" @error="checkimage(stage.ID)" height="80" class="cover pointer ml2" width="100%" alt="" v-if="stage.PHOTOS.length > 0">
                          <div class="border rounded p2 ml3 regular small" v-if="stage.PHOTOS.length < 1"><span>+ UPLOAD</span></div>
                          <el-upload  v-if="stage['PHOTOS'].length < 1"
                                class="col-12 p0 absolute imageuploader top-0 bottom-0 left-0 right-0 primarycolor white-background opacity50 flex line-height-1 justify-center items-center h5 not-rounded  flex-column"
                                action="#"
                                :on-change="handleFileChange"
                                :on-remove="removeImage"
                                :on-progress="handleProgress"
                                :before-upload="beforeFileUpload"
                                :auto-upload="false"
                                accept=".jpg, .jpeg, .png, .webp"
                                :file-list="fileList"
                                list-type="picture"
                                :limit="limitUpload"
                                :multiple="true"
                                :disabled="disable">
                                <div class="flex items-center justify-center p2">
                                    <span class=" relative">
                                      <i class="el-icon-plus"></i>
                                    </span>
                                </div>
                            </el-upload>
                          </div>
                      </div>
                      <div class="flex items-center px1 sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p1">
                        <p class="font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center">At anmode</p>
                        <button class="paymentbutton action-button font14 py1 flex items-center justify-center xs-ml-auto" @click="openrqueststagebydesc(stage, parseInt(index + 1) + '.' + parseInt(index2 + 1))" v-if="stage.STATUS === 'pending' || stage.STATUS === 'declined' || stage.STATUS === 'partially_paid'">
                          <span class="">Send betaling</span>
                        </button>
                        <button disabled class="paymentbutton flex items-center justify-center action-button font14 py1 xs-ml-auto" v-else-if="stage.STATUS === 'requested'">Anmodning sendt</button>
                      </div>
                  </template>
                  <div class="col-12 pl3" v-for="(item,index3) in stage.DESCRIPTION" :key="index3">
                    <p> {{item}} </p>
                  </div>
                  <div class="py1"></div>
                </el-collapse-item>
              </el-collapse>
            </div>
            </el-collapse-item>
            <!-- eslint-enable -->
          </el-collapse>
          </div>
        </div>
        <div class="py4">
        </div>
      </div>
    <b-modal centered hide-header hide-footer id="stagesthankyou" v-model="stagesthankyou" ref="stagesthankyou" size="lg"  no-close-on-esc no-close-on-backdrop>
        <div class="col-12 flex justify-between items-center pt1 p0 mx-auto modal-header">
          <button class="ml-auto h4 p0 primary-white-button pointer close" @click="closethankyou()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
      <div class="clearfix">
        <div class="m0 p0 lg-col-12 md-col-12 sm-col-12 center my2">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
              <path id="success" d="M25.957,81.66A42.642,42.642,0,1,1,42.5,85,42.362,42.362,0,0,1,25.957,81.66ZM4,42.5A38.5,38.5,0,1,0,42.5,4,38.544,38.544,0,0,0,4,42.5ZM34.707,57.372,22.3,45.527a2,2,0,0,1,2.762-2.894L36.088,53.161,59.525,30.789a2,2,0,1,1,2.762,2.893L37.469,57.372a2,2,0,0,1-2.762,0Z" fill="#4dcf55"/>
            </svg>
          </span>
        </div>
        <div class="flex flex-column darkblue center  mb3">
          <p class="h3 semi-bold my2">Din anmodning er blevet sendt</p>
          <p class="h6 my3">Du vil modtage en e-mail, hvis og når din anmodning er godkendt.</p>
        </div>
        </div>
    </b-modal>
    <b-modal centered hide-header hide-footer id="rqueststagebydescID" v-model="rqueststagebydescID" ref="rqueststagebydescID" size="lg"  no-close-on-esc no-close-on-backdrop v-if="selectedstage">
      <div class="col-12 flex justify-center items-center p0 m0 darkblue-background relative py3 mb2">
        <p class="white m0 semi-bold h3">Anmod om betaling</p>
        <button class="pointer absolute right-0 top-0" @click="closerqueststagebydesc()">
          <i class="white el-icon-circle-close pt1 pr1"></i>
        </button>
      </div>
      <div class="col-12 m0 p0">
        <div class="col-10 mx-auto py2 border muted-border border-top-0 border-left-0 border-right-0 mb2">
          <div class="flex justify-around">
            <div class="p0 m0 col-11 flex flex-column">
              <div class="flex">
                <p class="h5 semi-bold">{{selectedstage.INDUSTRY}} - {{itemsjobindustry[selectedstage.JOB_INDUSTRY_ID]}}</p>
                <p class="p0 h5 m0  ml-auto bold">{{parseFloat(selectedstage['PRICE_DEDUCTED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}
                </p>
              </div>
              <p class="m0 p0 font14" v-for="(item,index3) in selectedstage['DESCRIPTION']" :key="index3">
              <span class="">{{item.replace('- ') | truncate(80, '...')}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 m0 p0 flex flex-column">
        <div class="col-9 mx-auto  darkblue center mb2">
          <div class="h6 p1 muted-background flex"><p class="p0 m0 mr-auto">Ikke betalt</p><p class="p0 m0 ml-auto">{{parseFloat(selectedstage['PRICE_DEDUCTED'] - selectedstage['PAYMENT_RELEASED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})
            }}</p></div>
          <div class="h6 p1 muted-background flex"><p class="p0 m0 mr-auto">Betalt</p><p class="p0 m0 ml-auto">{{parseFloat(selectedstage['PAYMENT_RELEASED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})}}</p></div>
        </div>
        <div class="col-9 mx-auto darkblue center mb2 flex justify-end">
          <div class="flex justify-end items-center">
            <span class="px2 flex items-center"><el-checkbox v-model="stagefullpayment">Fuld</el-checkbox></span>
            <el-input type="number" :max="selectedstage['PRICE']" v-model.number="stageamount" @change="changerequesamount()" class="col-4 p0 el-input left-align"></el-input>
            <span class="px1">kr.</span>
          </div>
        </div>
        <div class="mb2 col-9 mx-auto">
          <label>Kommentar</label>
          <el-input type="textarea" v-model="stagecomment" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Tilføj evt. dine betingelser for tilbuddet">
          </el-input>
        </div>
        <div class="col-9 mx-auto  darkblue center my3">
          <button class="action-button p2 center col-12" @click="requeststage(selectedstage['ID'])">
            <span class="h5 semi-bold ">Send anmodning</span>
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal centered hide-footer hide-header id="reasondeclinemodal" v-model="reasondeclinemodal" ref="reasondeclinemodal" size="lg"  no-close-on-esc no-close-on-backdrop>
        <div class="col-12 flex justify-between items-center pt1 p0 mx-auto">
          <button class="ml-auto h4 p0 primary-white-button pointer" @click="closetwdecline()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
      <div class="clearfix">
        <div class="m0 p0 lg-col-12 md-col-12 sm-col-12 my2">
          <p class="darkblue col-12 h5 my2">Årsag til tilbagegang</p>
        </div>
        <div class="flex flex-column darkblue center  mb3">
          <p class="h6 center line-height-golden p2">
            {{reasontext}}
          </p>
        </div>
        </div>
    </b-modal>
    <b-modal centered hide-footer hide-header id="gallerystage" class="m0 p0" width="100%" v-model="gallerystage" size="xl" ref="gallerystage">
    <div class="col-8 flex justify-between items-center p0 mx-auto absolute p4 z4">
      <button class="mr-auto p0 primary-white-button pointer" @click="closengallery()">
        <i class="el-icon-back h1"></i>
      </button>
    </div>
    <div class="mx-auto" v-if="modalimageloading">
      <div class="loader"></div>
    </div>
    <div class="flex flex-row col-12 m0 p0 height-full" v-else>
        <div class="p0 m0 col-10 mt4 pt3">
          <el-carousel :interval="4000" arrow="none" trigger="click" ref="galleryone" :setActiveItem="activestagephoto" :autoplay="false" :type="typegallery" id="galleryone" width="100%" indicator-position="outside">
            <el-carousel-item v-for="(item,index) in photos" :name="index.toString()" :key="index">
              <img id="imagedivreview" height="100%" class="cover pointer" :src="item" width="100%" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="white-background col-2 flex flex-column" >
          <div id="sidebarphoto" class="flex flex-column overflow-auto">
            <div class="p2" v-for="(itempreview,index) in photos" :key="index">
              <img id="imagedpreview" height="200px" class="cover pointer" @click="setactivestagephoto(index)" :src="itempreview + '?width=250&height=200'" width="250px" alt="">
            </div>
          </div>
          <div class="mx-auto center pb2 pt3" style="border: 3px dashed rgb(25, 163, 192);" >
            <!-- <span class="p3"><i class="h3 el-icon-plus darkblue"></i></span> -->
            <el-upload class="px3" action="#"
                :on-change="handleFileChange"
                :on-remove="removeImage"
                :on-progress="handleProgress"
                :before-upload="beforeFileUpload"
                :auto-upload="false"
                accept=".jpg, .jpeg, .png, .webp"
                :file-list="fileList"
                list-type="picture"
                :limit="limitUpload"
                :multiple="false"
                :disabled="disable">
                <div class="flex items-center justify-center p0">
                    <span class=" relative">
                      <i class="h3 el-icon-plus darkblue"></i>
                    </span>
                </div>
            </el-upload>
          </div>
        </div>
    </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import VueFormWizard from 'vue-form-wizard'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'Paymentmanagement',
  components: {
    Simplert,
    VueFormWizard,
    ErrorHandler
  },
  computed: {
  },
  data: function () {
    return {
      fileList: [],
      loading: false,
      haaid: '',
      salesPersonbitrix: '',
      stages: [],
      stagesid: [],
      test: false,
      images: [],
      stagesswitch: [],
      invitationId: '',
      totalamount: 0,
      limitUpload: 5,
      disable: false,
      fileListTemp: [],
      totalImageSize: '',
      showMobile: false,
      stagesthankyou: false,
      message: '',
      reasondeclinemodal: false,
      reasontext: '',
      gallerystage: false,
      typegallery: '',
      formData: [],
      photos: [],
      activeTab: [],
      allstagesArr: [],
      rqueststagebydescID: false,
      stagecomment: '',
      stagefullpayment: false,
      stageamount: 0,
      selectedstage: {},
      selectedID: '',
      innerimageloading: false,
      activestagephoto: '0',
      currentContractData: {},
      contractID: '',
      totalproject: 0,
      totalrelease: 0,
      modalimageloading: false,
      currentstageindex: '',
      itemsjobindustry: {},
      activeJobID: 0,
      depositedamount: 0,
      walletamount: 0,
      partnerchildprojects: [],
      childprojects: [],
      contractType: '',
      mangelamount: 0,
      tilbudpris: 0,
      currentProjectData: {},
      contactId: ''
    }
  },
  watch: {
  },
  created () {
    this.projectId = this.$route.query.projectId
    this.gettaskbitrix()
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    checkimage (stageID) {
      // var image = 'https://haandvaerker.dk/uploads/00.webp'
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp'
      var getimage = document.getElementById('imagedivreview' + stageID)
      getimage.src = image2
    },
    nextStep () {
      this.$refs.anbefalhomeowners.nextTab()
    },
    backstep () {
      this.$refs.anbefalhomeowners.prevTab()
    },
    showthankyou () {
      this.stagesthankyou = true
    },
    closethankyou () {
      this.stagesthankyou = false
      // this.$router.push('/customer-projects/project-dashboard')
    },
    changerequesamount () {
      if (Number(this.stageamount) === this.selectedstage['PRICE']) {
        this.stagefullpayment = true
      } else {
        this.stagefullpayment = false
      }
    },
    openrqueststagebydesc (stage, index) {
      if (stage.PHOTOS.length < 1) {
        this.$message({
          type: 'error',
          message: 'Inkluder venligst billeder af disse stadier'
        })
        return false
      }
      this.selectedstage = stage
      this.stagefullpayment = true
      this.stageamount = parseFloat(stage['PRICE_DEDUCTED'] - stage['PAYMENT_RELEASED'])
      this.selectedstage['descindex'] = index
      this.rqueststagebydescID = true
    },
    closerqueststagebydesc () {
      this.rqueststagebydescID = false
      this.selectedstage = {}
    },
    showdecline (text) {
      this.reasontext = text
      this.reasondeclinemodal = true
    },
    closetwdecline () {
      this.reasondeclinemodal = false
    },
    removeImage (file, fileList) {
      const index = fileList.indexOf(file)
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
      const index2 = fileList.indexOf(file.raw)
      if (index2 > -1) {
        this.images.splice(index2, 1)
      }
    },
    handleFileChange (file, fileList) {
      const isLt1M = file.size / 1000 / 1000 < 7
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      this.fileList = fileList.slice(0)
      this.images.push(file.raw)
      this.formData = new FormData()
      this.formData.append('files[]', file.raw)
      this.addimage()
    },
    getstageid (stageID) {
      this.selectedID = stageID
    },
    gettaskbitrix () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'industries/full/', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
          this.getstages()
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    handleProgress (event, file, fileList) {
      console.log('event', event)
    },
    beforeFileUpload (file) {
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      const isLt1M = file.size / 1000 / 1000 < 17
      this.checkImageSizes()
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          })
          return false
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      return isIMAGE && isLt1M
    },
    checkImageSizes () {
      var fileSize = 0
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size)
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length
        // this.$message.error("Den samlede størrelse af billeder oversteg 30 MB.");
      } else {
        this.limitUpload = 50
      }
      this.totalImageSize = fileSize
    },
    validatestep1 () {
      if (this.stagesid.length < 1) {
        this.$message({
          type: 'error',
          message: 'Vælg venligst 1 betaling at anmode om afventende.'
        })
        return false
      }
      return true
    },
    addstage (id) {
      if (this.stagesid.indexOf(id) > -1) {
        this.stagesid.splice(this.stagesid.indexOf(id), 1)
      } else {
        this.stagesid.push(id)
      }
      this.stageerror = false
    },
    addimage () {
      this.innerimageloading = true
      this.modalimageloading = true
      if (this.images.length > 5) {
        this.$message({
          type: 'error',
          message: 'Upload kun 5 filer til denne anmodning.'
        })
        return false
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.post(this.$bitrixapi + 'partner/project/uploadPaymentStagePhotos?paymentStageId=' + this.selectedID, this.formData, { headers }, { emulateJSON: true }).then(
        response => {
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.innerimageloading = false
          this.selectedID = ''
          this.getstages()
        },
        response => {
          this.innerimageloading = false
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
          this.selectedID = ''
        }
      )
    },
    requeststage (id) {
      this.closerqueststagebydesc()
      this.loading = true
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        notes: this.stagecomment
      }
      this.$http.post(this.$bitrixapi + 'partner/paymentStages/requestPartial?projectId=' + this.projectId + '&paymentStageId=' + id, data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.showthankyou()
            this.selectedstage = {}
            this.getstages()
          }
        },
        (response) => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
          this.getstages()
        }
      )
    },
    getstages () {
      if (!this.gallerystage) {
        this.loading = true
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/paymentStagesV2?projectId=' + this.projectId, { headers }, data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.contractID = res.data.CONTRACT_ID
              this.stages = res.data.STAGES
              // var tilbudprissum = 0
              var enterprisername = []
              var allstagesbyinterpriser = []
              res.data.STAGES.forEach(a => {
                if (a.TYPE !== 'deficiency') {
                  var industryid = a.JOB_INDUSTRY_ID !== 0 ? a.JOB_INDUSTRY_ID : 'extra_work'
                  var industryi = a.JOB_INDUSTRY_ID !== 0 ? this.itemsjobindustry[a.JOB_INDUSTRY_ID] : 0
                  if (!enterprisername.includes(industryid + '-' + industryi)) {
                    enterprisername.push(industryid + '-' + industryi)
                    this.activeTab.push(industryid.toString())
                  }
                  // tilbudprissum += a.PRICE_VAT
                }
                if (a.CONTRACT_TYPE === 'normal' && a.TYPE === 'deficiency') {
                  this.mangelamount += a.PRICE_DEDUCTED
                }
              })
              enterprisername.forEach(b => {
                var allstagesObj = {}
                allstagesObj['enterpriserstages'] = []
                allstagesObj['enterpriserID'] = b.split('-')[0]
                allstagesObj['enterpriserNAME'] = b.split('-')[1]
                allstagesObj['enterpriserstages'] = res.data.STAGES.filter(c => {
                  return b === c.JOB_INDUSTRY_ID + '-' + this.itemsjobindustry[c.JOB_INDUSTRY_ID] || (b === c.CONTRACT_TYPE + '-' + 0 && c.TYPE === 'normal')
                })
                allstagesbyinterpriser.push(allstagesObj)
                const sum = allstagesObj['enterpriserstages'].reduce((accumulator, object) => {
                  return accumulator + object['PAYMENT_RELEASED']
                }, 0)
                this.totalrelease += sum
              })
              this.allstagesArr = allstagesbyinterpriser
              this.depositedamount = res.data.STAGES[res.data.STAGES.length - 1].PRICE
              this.totalamount = res.data.CONTRACT ? res.data.CONTRACT.AMOUNT : 0
              // this.tilbudpris = tilbudprissum
              this.tilbudpris = res.data.TOTAL_AMOUNT_VAT
              // this.walletamount = res.data.TRANSACTION ? res.data.TRANSACTION.AMOUNT - parseInt(res.data.CONTRACT.TRANSACTIONCOST) : 0
              if (this.gallerystage) {
                this.photos = this.allstagesArr[this.currentstageindex.split('-')[0]]['enterpriserstages'][this.currentstageindex.split('-')[1]]['PHOTOS']
                this.modalimageloading = false
                setTimeout(() => {
                  document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px'
                }, 100)
              }
              // var thisvar = this
              // this.stages.forEach(a => {
              //   thisvar.stagesswitch.push(false)
              // })
              // this.getcontractdetails()
              this.loading = false
              this.displayProjects()
            }
          },
          response => {
            this.loading = false
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        )
    },
    getcontractdetails () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data) {
            this.currentContractData = res.data
          }
        },
        response => {
          var error = response.body.message
          this.$refs.errorMsg.showMsg(error)
        })
    },
    opengallery (images, index = '', index2 = '') {
      this.currentstageindex = index + '-' + index2
      this.photos = []
      this.photos = images
      this.gallerystage = true
      this.typegallery = this.showMobile ? 'none' : 'card'
      setTimeout(() => {
        document.getElementById('gallerystage___BV_modal_body_').style.width = window.innerWidth + 'px'
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px'
        document.getElementById('gallerystage___BV_modal_body_').style.padding = 0 + 'px'
        // var isstage = document.querySelector('.el-carousel__item.is-active.el-carousel__item--card.is-in-stage')
        // isstage.style.transform = isstage.style.transform
        // 'translateX(0,' + val + ')'
      }, 200)
    },
    closengallery () {
      this.photos = []
      this.gallerystage = false
    },
    setactivestagephoto (index) {
      this.activestagephoto = index.toString()
      this.$refs.galleryone.setActiveItem(this.activestagephoto)
    },
    handleChange (event) {
      console.log('event', event)
    },
    displayProjects () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectId, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.contractType = res.CONTRACT_TYPE
          this.contactId = res.HOMEOWNER.ID
          this.childprojects = res.CHILD_PROJECTS
          this.currentProjectData = res
        },
        response => {
          this.loading = false
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    gotodashboard () {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.currentProjectData.ID + '&contactID=' + this.currentProjectData.HOMEOWNER.ID + '&parentID=' + this.currentProjectData.PARENT_ID + '&industryID=' + this.currentProjectData.ENTERPRISE_INDUSTRY + '&offertype=' + this.currentProjectData.OFFER_TYPE + '&childprojects=' + JSON.stringify(this.currentProjectData.CHILD_PROJECTS) + '&contracttype=' + this.currentProjectData.CONTRACT_TYPE + '&projecttitle=' + this.currentProjectData.NAME)
    }
  }
}
</script>
<style>
#stagesthankyou .modal-header {
  display: block;
}
  #paymentmanagement .el-collapse {
      border-top: 0px solid #EBEEF5;
      border-bottom: 0px solid #EBEEF5;
  }
  #paymentmanagement .jobindustryheader {
    background-color: #fff
  }
  #jobindustryheader .el-collapse-item__header {
    background-color: #ffff!important;
    height: 120px;
  }
  .imageuploader {
    display: none;
  }
  #gallerystage .el-carousel__item--card.is-active {
    display: block;
  }
  #gallerystage .el-carousel__item {
    display: block;
  }
  #gallerystage .el-carousel__item--card {
    width: 65%;
  }
  #gallerystage .el-upload-list {
    display: none;
  }
  #paymentmanagement .headerboxitem {
    border: 0.5px solid #003645;
    border-radius: 5px;
    width: 225px;
    height: 125px;
  }
  #rqueststagebydescID___BV_modal_body_ {
    padding: 0px;
  }
  #paymentmanagement .el-collapse-item__header {
    background: #f1efef;
  }
  #imageuploader:hover > div > .imageuploader {
    display: block!important;
  }
  #paymentmanagement .el-collapse-item__header {
    font-size: 18px;
    color: #003645;
    font-weight: 600;
    /** padding-top: 10px;
    padding-left: 10px;
    **/
    padding-bottom: 10px;
  }
  #paymentmanagement .wizard-progress-with-circle {
    display: inherit!important;
  }
  #paymentmanagement .wizard-progress-bar {
    background: #19a3c0!important;
    position: relative;
    z-index: 2;
  }
  #paymentmanagement .wizard-progress-with-circle:after {
    width: 100%;
    height: 1.99px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 0;
    background: #c5c5c5;
    content: '';
    display: block;
  }
  #gallerystage___BV_modal_content_ {
    height: 100%;
  }
  #gallerystage___BV_modal_content_ .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  #gallerystage .modal-dialog {
    width: 100%;
    height: 100%;
    margin: 0px;
    margin-left: inherit;
  }
  #gallerystage .el-carousel__arrow {
    display: none;
  }
  #gallerystage .el-carousel__indicator {
    display: none;
  }
  #gallerystage___BV_modal_content_ .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  #gallerystage___BV_modal_content_ {
    background: transparent!important;
  }
  #gallerystage___BV_modal_content_ .modal-content{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
  #galleryone .el-carousel__container {
    height: 750px;
  }
  #gallerystage___BV_modal_body_  {
    margin-right: auto;
    margin-left: auto;
  }
  #gallerystage___BV_modal_content_ .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  #paymentmanagement .action-button {
    border: none;
  }
  #paymentmanagement .close {
      color: #003645!important;
      background-color: #fff!important;
  }
  #paymentmanagement button.close  {
      padding: 0px!important;
  }
  #paymentmanagement .delete-button {
    background: red;
    color: #fff;
  }
  #reasondeclinemodal___BV_modal_body_ .close {
        color: #003645!important;
        background-color: #fff!important;
  }
  #reasondeclinemodal___BV_modal_body_ button.close  {
        padding: 0px!important;
  }
  #gallerystage___BV_modal_body_ .close {
        color: #c2f2ff!important;
        background-color: transparent!important;
  }
  #gallerystage___BV_modal_body_ button.close  {
        padding: 0px!important;
  }
  #paymentmanagement  .vue-form-wizard {
      padding-bottom: 2rem;
      margin-bottom: 2rem;
  }
  #paymentmanagement .vs__dropdown-toggle {
    border:0;
    background: rgba(230, 234, 235, 0.5);
    width:100%;
  }
  #paymentmanagement .wizard-card-footer {
    display: none;
  }
  #paymentmanagement .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
    font-style: normal;
    font-size: 19px;
  }
  #paymentmanagement .el-upload-list--picture .el-upload-list__item-name i {
    display: none;
  }
  #paymentmanagement .el-upload-dragger {
    width: 100%;
  }
  #paymentmanagement .el-upload {
    width: 100%;
  }
  #paymentmanagement .primarycolor-border {
      border-color: #19A3C080!important;
  }
  
  #paymentmanagement .vue-form-wizard .wizard-nav-pills {
      display: flex!important;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
  }
  #paymentmanagement .vue-form-wizard.md .wizard-icon-circle {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  #comment .el-textarea__inner{
    min-height: 102px!important;
  }
  #paymentmanagement .wizard-header {
    display: inline!important;
  }
  #paymentmanagement .vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
      top: 58px;
      height: 4px;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      margin-bottom: 30px;
  }
  #paymentmanagement .wizard-footer-left .wizard-btn {
    display: none;
    border: 1px solid rgba(178,190,195, 0.5)!important;
    color: rgba(178,190,195, 0.5)!important;
    background-color: #00968808!important;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-notosans';
    font-weight: 600!important;
  }
  #paymentmanagement .vue-form-wizard .wizard-card-footer .wizard-footer-left {
    display: none;
  }
  #paymentmanagement .wizard-footer-left .wizard-btn:hover {
      background: rgba(178,190,195, 0.5);
      color: white;
      display: none;
  }
  #paymentmanagement .dropzone {
    width: 100%;
  }
  #paymentmanagement .paymentbutton {
    width: 150px;
    height: 40px;
  }
  #paymentmanagement .totalWallet {
    font-size: 45px;
  }
  #paymentmanagement .yellow-button {
    background: #FFDD80 0% 0% no-repeat padding-box;
    border-radius: 1px;
    opacity: 1;
    cursor: default;
    color: #927E47;
    border: none;
  }
  .height-full {
    height: 100%;
  }
  #paymentmanagement .primary-button {
    cursor: default;
  }
  #paymentmanagement .dark-button {
    background: #003645 0% 0% no-repeat padding-box;
    border-radius: 1px;
    cursor: default;
    letter-spacing: 0px;
    color: #FFFFFF;
  }
  .font14 {
    font-size: 14px;
  }
  .font12 {
    font-size: 12px;
  }
  .font10 {
    font-size: 10px;
  }
  #paidbutton .vue-form-wizard .action-button {
    padding: 0px!important;
  }
  #paymentmanagement  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
#paymentmanagement  .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#paymentmanagement  .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#paymentmanagement  .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#paymentmanagement  .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
#gallerystage  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
#gallerystage  .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#gallerystage  .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#gallerystage  .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#gallerystage  .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
  #paymentmanagement  .wizard-footer-right .wizard-btn {
    display: none;
    background: rgba(77, 207, 85, 1.0)!important;
    background-color: rgba(77, 207, 85, 1.0)!important;
    color: #fff;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-notosans';
    font-weight: 600!important;
  }
  #paymentmanagement .wizard-icon-circle.checked {
    background: rgb(25, 163, 192)!important;
    color: #fff!important;
  }
  #paymentmanagement .vue-form-wizard .wizard-icon-circle {
    font-size: 12px;
    font-weight: 500;
  }
  #paymentmanagement  .wizard-nav .stepTitle {
    width:100%;
    color: lighten(#5a5a5a, 40%);
    background-color: #fff;
    padding: 1rem 0.25rem 0.5rem 0rem;
    text-align: center;
    font-weight:400;
    font-size: 13.5px;
    border-bottom: 3px solid #ffff;
  }
  #paymentmanagement  .wizard-nav .stepTitle.active {
    background-color: #fff;
    color: lighten(#5a5a5a, 40%)!important;
  }
  #paymentmanagement  .wizard-nav .stepTitle::after {
    height: 0;
  }
  #paymentmanagement  .wizard-nav .checked + .stepTitle {
    color: rgba(77, 207, 85, 1.0);
  }
  @media (max-width: 420px) {
    #paymentmanagement .totalWallet {
      font-size: 22px;
    }
    #paymentmanagement .totalWallettext {
      font-size: 16px;
    }
    #paymentmanagement .wizard-header {
      display: none!important;
    }
    #paymentmanagement .paymentbutton {
      width: 121px;
      height: 25px;
      font-size: 10px!important;
    }
    #paymentmanagement .el-switch__core {
      width: 25px!important;
      height: 16px!important;
    }
    #paymentmanagement .el-switch__core:after {
      width: 12px!important;
      height: 12px!important;
    }
    #paymentmanagement .el-switch.is-checked .el-switch__core::after {
      margin-left: -13px!important;
    }
    .mfont10 {
      font-size: 10px;
    }
    .mpx2 {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .mpx1 {
      padding-left: .5rem;
      padding-right: .5rem;
    }
    #galleryone .el-carousel__container {
      height: 345px;
    }
    #paymentmanagement .headerboxitem {
      width: 150px;
      height: 75px;
    }
    #paymentmanagement .xs-h6 {
      font-size: 1rem;
    }
    #jobindustryheader .el-collapse-item__header {
    height: 297px;
    display: block;
    }
    .xs-ml-auto {
      margin-left: auto;
      margin-right: unset!important;
    }
  }
</style>



// WEBPACK FOOTER //
// payment-management.vue?1001e118